import type { CategoryTab } from '../components/shared/CategoryGroup';

export interface CategoryGroupResult<T> {
  /** null = groupe « sans catégorie » (rendu en dernier, sans titre). */
  catalog_category_id: number | null;
  name: string | null;
  items: T[];
}

/**
 * Regroupe des items par catégorie (dans l'ordre de `categories`), les non-catégorisés en dernier.
 * Les groupes vides sont omis. Partagé entre le tunnel de réservation et le tunnel carte cadeau.
 */
export function groupItemsByCategory<T>(
  items: T[],
  categories: CategoryTab[],
  getCategoryId: (item: T) => number | null | undefined,
): CategoryGroupResult<T>[] {
  const grouped = new Map<number, { name: string; items: T[] }>();
  for (const cat of categories) grouped.set(cat.catalog_category_id, { name: cat.name, items: [] });

  const uncategorized: T[] = [];
  for (const item of items) {
    const catId = getCategoryId(item);
    const bucket = catId != null ? grouped.get(catId) : undefined;
    if (bucket) bucket.items.push(item);
    else uncategorized.push(item);
  }

  const result: CategoryGroupResult<T>[] = [];
  for (const [catId, group] of grouped) {
    if (group.items.length === 0) continue;
    result.push({ catalog_category_id: catId, name: group.name, items: group.items });
  }
  if (uncategorized.length > 0) result.push({ catalog_category_id: null, name: null, items: uncategorized });
  return result;
}
